import axios from 'axios';

// ======================== Configuration ========================
const BASE_URL = 'https://loyalty.bom.asia';

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

// Interceptors
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// ======================== Role Functions ========================

/**
 * Lấy tất cả Role
 */
export const loadingAllRole = async () => {
  try {
    const response = await apiClient.get('/api/role');
    return response.data.roles || [];
  } catch (error) {
    console.error('Error fetching roles:', error);
    throw error.response?.data || { message: 'Failed to fetch roles' };
  }
};

/**
 * Lấy Role theo ID
 */
export const getRoleById = async (id) => {
  try {
    const response = await apiClient.get(`/api/role/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching role by ID:', error);
    throw error.response?.data || { message: 'Failed to fetch role' };
  }
};

/**
 * Tạo Role mới
 */
export const createRole = async (roleData) => {
  try {
    const response = await apiClient.post('/api/role', roleData);
    return response.data;
  } catch (error) {
    console.error('Error creating role:', error);
    throw error.response?.data || { message: 'Failed to create role' };
  }
};

/**
 * Cập nhật Role theo ID
 */
export const updateRole = async (id, roleData) => {
  try {
    const response = await apiClient.put(`/api/role/${id}`, roleData);
    return response.data;
  } catch (error) {
    console.error('Error updating role:', error);
    throw error.response?.data || { message: 'Failed to update role' };
  }
};

/**
 * Xóa Role theo ID
 */
export const deleteRole = async (id) => {
  try {
    const response = await apiClient.delete(`/api/role/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting role:', error);
    throw error.response?.data || { message: 'Failed to delete role' };
  }
};

// ======================== Default Export ========================
export default {
  loadingAllRole,
  getRoleById,
  createRole,
  updateRole,
  deleteRole,
};

